import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Kundendaten", -1)
const _hoisted_3 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_4 = {
  key: 1,
  class: "w-full flex justify-between mt-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-left font-semibold" }, "Kunden Nr.", -1)
const _hoisted_6 = { class: "text-right" }

import { SwiperSlide } from 'swiper/vue';
import { useSelectedProject } from '@/store/selectedProject'
import DynamicSwiper from '../../dynamicSwiper.vue';
import SwiperDiv from '@/components/DetailPage/SwiperDiv.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerData',
  setup(__props) {

const selectedProjectStore = useSelectedProject()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_unref(selectedProjectStore).customer && !_unref(selectedProjectStore).contact)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Keine Kundendaten für dieses Projekt gefunden "))
      : _createCommentVNode("", true),
    (_unref(selectedProjectStore).customer && _unref(selectedProjectStore).customer.cid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(selectedProjectStore).customer.cid), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(selectedProjectStore).customer || _unref(selectedProjectStore).contact)
      ? (_openBlock(), _createBlock(DynamicSwiper, {
          key: 2,
          pagination: true,
          "class-swiper": "w-full mt-4"
        }, {
          default: _withCtx(() => [
            (_unref(selectedProjectStore).customer)
              ? (_openBlock(), _createBlock(_unref(SwiperSlide), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(SwiperDiv, {
                      "title-start": _unref(selectedProjectStore).customer.name1,
                      "title-end": "",
                      city: _unref(selectedProjectStore).customer.zip + ' ' + _unref(selectedProjectStore).customer.city,
                      address: _unref(selectedProjectStore).customer.street + ' ' + _unref(selectedProjectStore).customer.no,
                      phone: _unref(selectedProjectStore).customer.phone,
                      "mobile-phone": _unref(selectedProjectStore).customer.mobile,
                      email: _unref(selectedProjectStore).customer.email
                    }, null, 8, ["title-start", "city", "address", "phone", "mobile-phone", "email"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(selectedProjectStore).contact)
              ? (_openBlock(), _createBlock(_unref(SwiperSlide), { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(SwiperDiv, {
                      "title-start": "Ansprechpartner",
                      "title-end": _unref(selectedProjectStore).contact.first_name + ' ' + _unref(selectedProjectStore).contact.last_name,
                      city: _unref(selectedProjectStore).contact.zip + ' ' + _unref(selectedProjectStore).contact.city,
                      address: _unref(selectedProjectStore).contact.street + ' ' + _unref(selectedProjectStore).contact.no,
                      phone: _unref(selectedProjectStore).contact.phone,
                      "mobile-phone": _unref(selectedProjectStore).contact.mobile,
                      email: _unref(selectedProjectStore).contact.email,
                      fax: _unref(selectedProjectStore).contact.fax
                    }, null, 8, ["title-end", "city", "address", "phone", "mobile-phone", "email", "fax"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})